import React from "react";
import { BsBoxArrowInUpRight as OpenIcon } from "@react-icons/all-files/bs/BsBoxArrowInUpRight";
import CallIcon from "@mui/icons-material/Call";
import { classNames } from "repoV2/utils/common/render/classNames";
import { isEmpty } from "@Utils";
import { useIsDesktop } from "repoV2/utils/common/render/screen";
import { FollowerCountIcons } from "@Modules/hostPage/FollowerCountIcons";
import { ReadMoreWrapper } from "@Modules/common/ReadMoreWrapper";
import ExlyImage from "repoV2/features/Common/modules/ExlyImage/ExlyImage";
import { IAboutCreator } from "./IAboutCreator";
import styles from "./aboutCreator.module.scss";
import commonStyles from "../commonStyles.module.scss";
import { DetailsSectionDivider } from "../DetailsSectionDivider";
import ShareOffering from "../ShareOffering";
import SslSection from "../SslSection";

const AboutCreator = ({
    hideComponent,
    hideCreatorHeader,
    creatorImg,
    meetYourCreatorTitle,
    creatorShortDescription,
    creatorDescription,
    minifyCreatorDescription,
    socialLinks,
    hideCheckoutAllOfferingsCta,
    hideShareEventCtaText,
    shareEventCtaText,
    onShareEventCtaClick,
    onContactCreatorCtaClick,
    checkoutAllOfferingsCtaText,
    contactCreatorCtaText,
}: IAboutCreator.IProps): JSX.Element | null => {
    const isDesktop = useIsDesktop();

    if (hideComponent) return null;

    return (
        <>
            <div className={commonStyles.detailsSection}>
                {hideShareEventCtaText ? null : (
                    <ShareOffering
                        onShareEventCtaClick={onShareEventCtaClick}
                        shareEventCtaText={shareEventCtaText}
                    />
                )}

                {!isDesktop && <SslSection />}
            </div>
            <div className={commonStyles.detailsSection}>
                <div className={commonStyles.detailsSectionBody}>
                    {hideCreatorHeader ? null : (
                        <>
                            <div className={styles.creatorMeta}>
                                <ExlyImage
                                    fetchWidth={120}
                                    width={120}
                                    src={creatorImg}
                                    alt="creator"
                                    className={styles.creatorPic}
                                />
                                <div className={styles.creatorInfo}>
                                    <div
                                        className={classNames(
                                            styles.creatorTitle,
                                            commonStyles.detailsSectionTitle
                                        )}
                                    >
                                        {meetYourCreatorTitle}
                                    </div>
                                    <div
                                        className={
                                            styles.creatorShortDescription
                                        }
                                    >
                                        {creatorShortDescription}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {creatorDescription ? (
                        <ReadMoreWrapper
                            id="creator_description"
                            collapsedHeight={isDesktop ? 120 : 190}
                            buttonClassName="mt-3"
                            showReadMoreFunctionality={minifyCreatorDescription}
                        >
                            <div
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{
                                    __html: creatorDescription,
                                }}
                                className={styles.creatorDescription}
                            />
                        </ReadMoreWrapper>
                    ) : null}
                    <br />
                    <FollowerCountIcons
                        socialLinks={socialLinks}
                        hideSocialIcons={isEmpty(socialLinks)}
                    />
                    <DetailsSectionDivider />

                    <div className={`row mt-4 mb-2 `}>
                        {!hideCheckoutAllOfferingsCta && (
                            <div className={`col-6 col-md-4 `}>
                                <a
                                    href="/"
                                    target="_blank"
                                    className={`${commonStyles.secondaryButton} w-100 d-flex align-items-center justify-content-center ${styles.contactBtn}`}
                                >
                                    {checkoutAllOfferingsCtaText}
                                    <OpenIcon className={`ml-2 `} />
                                </a>
                            </div>
                        )}
                        <div
                            className={`${
                                !hideCheckoutAllOfferingsCta
                                    ? "col-6"
                                    : "col-12"
                            } col-md-4 `}
                        >
                            <div
                                className={`${styles.textButton} w-100 d-flex align-items-center justify-content-center ${styles.contactBtn} pointer`}
                                onClick={onContactCreatorCtaClick}
                            >
                                {contactCreatorCtaText}
                                <CallIcon
                                    className={`${styles.callIcon} ml-2`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AboutCreator;
